import React from "react";
import { Link } from "react-router-dom";

export const WeddingBanner = () => (
  <section className="relative py-16 sm:py-24 overflow-hidden" data-testid="wedding-banner-section">
    <img src="/category-patteda.jpg" alt="Patteda Anchu Ilkal saree — iconic checked weave from Karnataka" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-charcoal/55" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 text-center">
      <p className="uppercase tracking-[0.3em] text-xs font-semibold text-gold">The Iconic Ilkal Check Weave</p>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-ivory mt-4 max-w-3xl mx-auto" data-testid="patteda-headline">
        PATTEDA ANCHU SAREES — ILKAL'S LIVING LEGEND
      </h2>
      <p className="text-ivory/80 text-base sm:text-lg mt-4 font-light max-w-xl mx-auto">
        The classic checked cotton drape woven in Ilkal for generations — for festivals, functions and everyday pride.
      </p>
      <Link
        to="/shop?category=patteda-anchu"
        data-testid="patteda-shop-btn"
        className="inline-block mt-8 bg-gold text-charcoal px-10 py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-ivory transition-colors"
      >
        Shop Patteda Anchu
      </Link>
    </div>
  </section>
);
